import { render } from "./Wind.vue?vue&type=template&id=377044a4"
import script from "./Wind.vue?vue&type=script&lang=ts"
export * from "./Wind.vue?vue&type=script&lang=ts"

import "./Wind.vue?vue&type=style&index=0&id=377044a4&rel=stylesheet&lang=scss"
script.render = render

export default script